import { Link } from "react-router-dom";

const NewArrivals = () => {
  return (
    <>
      <div className="inner-banner banner">
        <div className="container">
          <div className="inner-banner-txt">
            <h1 className="banner-banner-heading text-white fs-45">
              New arrivals
            </h1>
            <nav aria-label="breadcrumb" className="breadcrumb-nav">
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link to="/">Home</Link>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  About{" "}
                </li>
              </ol>
            </nav>
          </div>
        </div>
      </div>

      <section className="main-section product-section">
        <div className="container">
          <div className="main-title text-center mb-5">
            <h3 className="heading">
              New arr<span>iv</span>als
            </h3>
          </div>
          <div className="product-pg">
            <div className="row">
              <div className="col-lg-3 col-sm-12 col-xs-12">
                <aside className="product-fitler">
                  <button id="filter-btn-cls" className="lg-hide">
                    <span className="mbri-close" />
                  </button>
                  <div className="aside-widget">
                    <h5>NEW ARRIVALS</h5>
                    <ul>
                      <li>
                        <a href="#">SHOP BY CATEGORY </a>
                      </li>
                      <li>
                        <a href="#">The Cali Collection</a>
                      </li>
                      <li>
                        <a href="#">The Weekend Getaway</a>
                      </li>
                      <li>
                        <a href="#">Chelsea Freeman Collection</a>
                      </li>
                    </ul>
                  </div>
                  <div className="aside-widget">
                    <h5>Price</h5>
                    <div className="field">
                      <div className="price-range-slider">
                        <p className="range-value mb-2">
                          Price Range:{" "}
                          <input type="text" className="amount" readOnly="" />
                        </p>
                        <div className="slider-range" />
                      </div>
                    </div>
                    {/* field */}
                  </div>
                  <div className="aside-widget">
                    <h5>Size</h5>
                    <ul>
                      <li>
                        <label>
                          <input
                            type="checkbox"
                            className="form-control"
                            name=""
                            defaultValue=""
                          />{" "}
                          1(6)
                        </label>
                      </li>
                      <li>
                        <label>
                          <input
                            type="checkbox"
                            className="form-control"
                            name=""
                            defaultValue=""
                          />
                          3(9)
                        </label>
                      </li>
                      <li>
                        <label>
                          <input
                            type="checkbox"
                            className="form-control"
                            name=""
                            defaultValue=""
                          />
                          5.5(3)
                        </label>
                      </li>
                      <li>
                        <label>
                          <input
                            type="checkbox"
                            className="form-control"
                            name=""
                            defaultValue=""
                          />
                          6(6)
                        </label>
                      </li>
                      <li>
                        <label>
                          <input
                            type="checkbox"
                            className="form-control"
                            name=""
                            defaultValue=""
                          />
                          7(2)
                        </label>
                      </li>
                      <li>
                        <label>
                          <input
                            type="checkbox"
                            className="form-control"
                            name=""
                            defaultValue=""
                          />{" "}
                          onesize (6)
                        </label>
                      </li>
                    </ul>
                  </div>
                  <div className="aside-widget">
                    <h5>Style</h5>
                    <ul>
                      <li>
                        <label>
                          <input
                            type="checkbox"
                            className="form-control"
                            name=""
                            defaultValue=""
                          />{" "}
                          Boyfriend (10)
                        </label>
                      </li>
                      <li>
                        <label>
                          <input
                            type="checkbox"
                            className="form-control"
                            name=""
                            defaultValue=""
                          />
                          Dad(9)
                        </label>
                      </li>
                      <li>
                        <label>
                          <input
                            type="checkbox"
                            className="form-control"
                            name=""
                            defaultValue=""
                          />
                          Mom(3)
                        </label>
                      </li>
                      <li>
                        <label>
                          <input
                            type="checkbox"
                            className="form-control"
                            name=""
                            defaultValue=""
                          />
                          Platform(6)
                        </label>
                      </li>
                    </ul>
                  </div>
                  <div className="aside-widget">
                    <h5>Color</h5>
                    <ul>
                      <li>
                        <label>
                          <input
                            type="checkbox"
                            className="form-control"
                            name=""
                            defaultValue=""
                          />{" "}
                          Black(10)
                        </label>
                      </li>
                      <li>
                        <label>
                          <input
                            type="checkbox"
                            className="form-control"
                            name=""
                            defaultValue=""
                          />
                          Dark Wash
                        </label>
                      </li>
                      <li>
                        <label>
                          <input
                            type="checkbox"
                            className="form-control"
                            name=""
                            defaultValue=""
                          />
                          Mom(3)
                        </label>
                      </li>
                      <li>
                        <label>
                          <input
                            type="checkbox"
                            className="form-control"
                            name=""
                            defaultValue=""
                          />
                          Light Wash (6)
                        </label>
                      </li>
                    </ul>
                  </div>
                </aside>
              </div>
              {/*side bar */}
              <div className="col-lg-9 col-sm-12 col-xs-12">
                <div className="prd-sort-filter text-right">
                  <label>Sort By:</label>
                  <select className="form-select" name="sort">
                    <option value="featured" selected="">
                      Featured Items
                    </option>
                    <option value="newest">Newest Items</option>
                    <option value="bestselling">Best Selling</option>
                    <option value="alphaasc">A to Z</option>
                    <option value="alphadesc">Z to A</option>
                    <option value="avgcustomerreview">By Review</option>
                    <option value="priceasc">Price: Ascending</option>
                    <option value="pricedesc">Price: Descending</option>
                  </select>
                  <button id="filter-btn" className="lg-hide">
                    <span className="mbri-setting"> Fillter</span>
                  </button>
                </div>
                <div className="product-side-bar">
                  <div className="row">
                    <div className="col-lg-4 col-sm-4 col-xs-6">
                      <div className="product">
                        <div className="product-img">
                          <div className="status-bar">
                            <span className="prd-rating br-5 bg-darkgreen text-white">
                              4.4
                              <i className="lni lni-star" />{" "}
                            </span>
                            <span className="prd-stauts bg-site text-white br-5">
                              {" "}
                              Sold-Out
                            </span>
                            <span className="prd-stauts bg-green text-white br-5">
                              Stock
                            </span>
                            <button className="wishlist-btn">
                              <i className="lni lni-heart" />
                            </button>
                          </div>
                          <Link to="/product-detail">
                            <img
                              src="images/prd-1.jpg"
                              alt="whiteshut"
                              className="prd-default-img"
                            />
                            <img
                              src="images/prd-2.jpg"
                              alt=""
                              className="prd-hover-img"
                            />
                          </Link>
                          <div className="quick-section">
                            <button
                              className="quick-btn"
                              data-toggle="modal"
                              data-target="#modalshow"
                            >
                              Quick View
                            </button>
                          </div>
                        </div>
                        <div className="prd-info">
                          <h4 className="prd-name">
                            <Link to="/product-detail">
                              Astron Cotton Blended Regular Tops -
                              <span className="prd-color">Black</span>
                            </Link>
                          </h4>
                          <div className="prices">
                            <span>$30</span> <del>$70</del>{" "}
                            <span className="tcolor">63% Off</span>
                          </div>
                          <div className="color-option">
                            <ul className="list-style">
                              <li data-src="images/prd-1.jpg">
                                <label>
                                  <input
                                    type="radio"
                                    name="color-option"
                                    defaultChecked=""
                                    defaultValue="white"
                                  />
                                  <span
                                    className="form-option-variant"
                                    style={{ background: "#fbc101" }}
                                  />
                                </label>
                              </li>
                              <li data-src="images/prd-2.jpg">
                                <label>
                                  <input
                                    type="radio"
                                    name="color-option"
                                    defaultValue="black"
                                  />
                                  <span
                                    className="form-option-variant"
                                    style={{ background: "#b41e4e" }}
                                  />
                                </label>
                              </li>
                              <li data-src="images/prd-3.jpg">
                                <label>
                                  <input
                                    type="radio"
                                    name="color-option"
                                    defaultValue="red"
                                  />
                                  <span
                                    className="form-option-variant"
                                    style={{ background: "#f0afaf" }}
                                  />
                                </label>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* item */}
                    <div className="col-lg-4 col-sm-4 col-xs-6">
                      <div className="product">
                        <div className="product-img">
                          <div className="status-bar">
                            <span className="prd-rating br-5 bg-darkgreen text-white">
                              4.4
                              <i className="lni lni-star" />{" "}
                            </span>
                            <span className="prd-stauts bg-site text-white br-5">
                              {" "}
                              Sold-Out
                            </span>
                            <span className="prd-stauts bg-green text-white br-5">
                              Stock
                            </span>
                            <button className="wishlist-btn">
                              <i className="lni lni-heart" />
                            </button>
                          </div>
                          <a href="#">
                            <img
                              src="images/white-top.jpg"
                              alt="whiteshut"
                              className="prd-default-img"
                            />
                            <img
                              src="images/white-top-with-jacket.jpg"
                              alt=""
                              className="prd-hover-img"
                            />
                          </a>
                          <div className="quick-section">
                            <button
                              className="quick-btn"
                              data-toggle="modal"
                              data-target="#modalshow"
                            >
                              Quick View
                            </button>
                          </div>
                        </div>
                        <div className="prd-info">
                          <h4 className="prd-name">
                            <Link to="/product-detail">
                              Astron Cotton Blended Regular Tops -
                              <span className="prd-color">Black</span>
                            </Link>
                          </h4>
                          <div className="prices">
                            <span>$30</span> <del>$70</del>{" "}
                            <span className="tcolor">63% Off</span>
                          </div>
                          <div className="color-option">
                            <ul className="list-style">
                              <li data-src="images/white-top.jpg">
                                <label>
                                  <input
                                    type="radio"
                                    name="color-option"
                                    defaultValue="white"
                                  />
                                  <span
                                    className="form-option-variant"
                                    style={{ background: "#fff" }}
                                  />
                                </label>
                              </li>
                              <li data-src="images/white-top-2.jpg">
                                <label>
                                  <input
                                    type="radio"
                                    name="color-option"
                                    defaultValue="black"
                                  />
                                  <span
                                    className="form-option-variant"
                                    style={{ background: "#000" }}
                                  />
                                </label>
                              </li>
                              <li data-src="images/white-top-with-jacket.jpg">
                                <label>
                                  <input
                                    type="radio"
                                    name="color-option"
                                    defaultValue="red"
                                  />
                                  <span
                                    className="form-option-variant"
                                    style={{ background: "#f0afaf" }}
                                  />
                                </label>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* item */}
                    <div className="col-lg-4 col-sm-4 col-xs-6">
                      <div className="product">
                        <div className="product-img">
                          <div className="status-bar">
                            <span className="prd-rating br-5 bg-darkgreen text-white">
                              4.4
                              <i className="lni lni-star" />{" "}
                            </span>
                            <span className="prd-stauts bg-site text-white br-5">
                              {" "}
                              Sold-Out
                            </span>
                            <span className="prd-stauts bg-green text-white br-5">
                              Stock
                            </span>
                            <button className="wishlist-btn">
                              <i className="lni lni-heart" />
                            </button>
                          </div>
                          <a href="#">
                            <img
                              src="images/kasmiri.jpg"
                              alt="whiteshut"
                              className="prd-default-img"
                            />
                            <img
                              src="images/tranding.jpg"
                              alt=""
                              className="prd-hover-img"
                            />
                          </a>
                          <div className="quick-section">
                            <button
                              className="quick-btn"
                              data-toggle="modal"
                              data-target="#modalshow"
                            >
                              Quick View
                            </button>
                          </div>
                        </div>
                        <div className="prd-info">
                          <h4 className="prd-name">
                            <Link to="/product-detail">
                              Astron Cotton Blended Regular Tops -
                              <span className="prd-color">Black</span>
                            </Link>
                          </h4>
                          <div className="prices">
                            <span>$30</span> <del>$70</del>{" "}
                            <span className="tcolor">63% Off</span>
                          </div>
                          <div className="color-option">
                            <ul className="list-style">
                              <li data-src="images/kasmiri.jpg">
                                <label>
                                  <input
                                    type="radio"
                                    name="color-option"
                                    defaultValue="white"
                                  />
                                  <span
                                    className="form-option-variant"
                                    style={{ background: "#fff" }}
                                  />
                                </label>
                              </li>
                              <li data-src="images/black-top.jpg">
                                <label>
                                  <input
                                    type="radio"
                                    name="color-option"
                                    defaultValue="black"
                                  />
                                  <span
                                    className="form-option-variant"
                                    style={{ background: "#000" }}
                                  />
                                </label>
                              </li>
                              <li data-src="images/tranding.jpg">
                                <label>
                                  <input
                                    type="radio"
                                    name="color-option"
                                    defaultValue="red"
                                  />
                                  <span
                                    className="form-option-variant"
                                    style={{ background: "#f0afaf" }}
                                  />
                                </label>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* item */}
                    <div className="col-lg-4 col-sm-4 col-xs-6">
                      <div className="product">
                        <div className="product-img">
                          <div className="status-bar">
                            <span className="prd-rating br-5 bg-darkgreen text-white">
                              4.4
                              <i className="lni lni-star" />{" "}
                            </span>
                            <span className="prd-stauts bg-site text-white br-5">
                              {" "}
                              Sold-Out
                            </span>
                            <span className="prd-stauts bg-green text-white br-5">
                              Stock
                            </span>
                            <button className="wishlist-btn">
                              <i className="lni lni-heart" />
                            </button>
                          </div>
                          <a href="#">
                            <img
                              src="images/prd-1.jpg"
                              alt="whiteshut"
                              className="prd-default-img"
                            />
                            <img
                              src="images/prd-2.jpg"
                              alt=""
                              className="prd-hover-img"
                            />
                          </a>
                          <div className="quick-section">
                            <button
                              className="quick-btn"
                              data-toggle="modal"
                              data-target="#modalshow"
                            >
                              Quick View
                            </button>
                          </div>
                        </div>
                        <div className="prd-info">
                          <h4 className="prd-name">
                            <Link to="/product-detail">
                              Astron Cotton Blended Regular Tops -
                              <span className="prd-color">Black</span>
                            </Link>
                          </h4>
                          <div className="prices">
                            <span>$30</span> <del>$70</del>{" "}
                            <span className="tcolor">63% Off</span>
                          </div>
                          <div className="color-option">
                            <ul className="list-style">
                              <li data-src="images/prd-1.jpg">
                                <label>
                                  <input
                                    type="radio"
                                    name="color-option"
                                    defaultChecked=""
                                    defaultValue="white"
                                  />
                                  <span
                                    className="form-option-variant"
                                    style={{ background: "#fbc101" }}
                                  />
                                </label>
                              </li>
                              <li data-src="images/prd-2.jpg">
                                <label>
                                  <input
                                    type="radio"
                                    name="color-option"
                                    defaultValue="black"
                                  />
                                  <span
                                    className="form-option-variant"
                                    style={{ background: "#b41e4e" }}
                                  />
                                </label>
                              </li>
                              <li data-src="images/prd-3.jpg">
                                <label>
                                  <input
                                    type="radio"
                                    name="color-option"
                                    defaultValue="red"
                                  />
                                  <span
                                    className="form-option-variant"
                                    style={{ background: "#f0afaf" }}
                                  />
                                </label>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* item */}
                    <div className="col-lg-4 col-sm-4 col-xs-6">
                      <div className="product">
                        <div className="product-img">
                          <div className="status-bar">
                            <span className="prd-rating br-5 bg-darkgreen text-white">
                              4.4
                              <i className="lni lni-star" />{" "}
                            </span>
                            <span className="prd-stauts bg-site text-white br-5">
                              {" "}
                              Sold-Out
                            </span>
                            <span className="prd-stauts bg-green text-white br-5">
                              Stock
                            </span>
                            <button className="wishlist-btn">
                              <i className="lni lni-heart" />
                            </button>
                          </div>
                          <a href="#">
                            <img
                              src="images/white-top.jpg"
                              alt="whiteshut"
                              className="prd-default-img"
                            />
                            <img
                              src="images/white-top-with-jacket.jpg"
                              alt=""
                              className="prd-hover-img"
                            />
                          </a>
                          <div className="quick-section">
                            <button
                              className="quick-btn"
                              data-toggle="modal"
                              data-target="#modalshow"
                            >
                              Quick View
                            </button>
                          </div>
                        </div>
                        <div className="prd-info">
                          <h4 className="prd-name">
                            <Link to="/product-detail">
                              Astron Cotton Blended Regular Tops -
                              <span className="prd-color">Black</span>
                            </Link>
                          </h4>
                          <div className="prices">
                            <span>$30</span> <del>$70</del>{" "}
                            <span className="tcolor">63% Off</span>
                          </div>
                          <div className="color-option">
                            <ul className="list-style">
                              <li data-src="images/white-top.jpg">
                                <label>
                                  <input
                                    type="radio"
                                    name="color-option"
                                    defaultValue="white"
                                  />
                                  <span
                                    className="form-option-variant"
                                    style={{ background: "#fff" }}
                                  />
                                </label>
                              </li>
                              <li data-src="images/white-top-2.jpg">
                                <label>
                                  <input
                                    type="radio"
                                    name="color-option"
                                    defaultValue="black"
                                  />
                                  <span
                                    className="form-option-variant"
                                    style={{ background: "#000" }}
                                  />
                                </label>
                              </li>
                              <li data-src="images/white-top-with-jacket.jpg">
                                <label>
                                  <input
                                    type="radio"
                                    name="color-option"
                                    defaultValue="red"
                                  />
                                  <span
                                    className="form-option-variant"
                                    style={{ background: "#f0afaf" }}
                                  />
                                </label>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* item */}
                    <div className="col-lg-4 col-sm-4 col-xs-6">
                      <div className="product">
                        <div className="product-img">
                          <div className="status-bar">
                            <span className="prd-rating br-5 bg-darkgreen text-white">
                              4.4
                              <i className="lni lni-star" />{" "}
                            </span>
                            <span className="prd-stauts bg-site text-white br-5">
                              {" "}
                              Sold-Out
                            </span>
                            <span className="prd-stauts bg-green text-white br-5">
                              Stock
                            </span>
                            <button className="wishlist-btn">
                              <i className="lni lni-heart" />
                            </button>
                          </div>
                          <a href="#">
                            <img
                              src="images/kasmiri.jpg"
                              alt="whiteshut"
                              className="prd-default-img"
                            />
                            <img
                              src="images/tranding.jpg"
                              alt=""
                              className="prd-hover-img"
                            />
                          </a>
                          <div className="quick-section">
                            <button
                              className="quick-btn"
                              data-toggle="modal"
                              data-target="#modalshow"
                            >
                              Quick View
                            </button>
                          </div>
                        </div>
                        <div className="prd-info">
                          <h4 className="prd-name">
                            <Link to="/product-detail">
                              Astron Cotton Blended Regular Tops -
                              <span className="prd-color">Black</span>
                            </Link>
                          </h4>
                          <div className="prices">
                            <span>$30</span> <del>$70</del>{" "}
                            <span className="tcolor">63% Off</span>
                          </div>
                          <div className="color-option">
                            <ul className="list-style">
                              <li data-src="images/kasmiri.jpg">
                                <label>
                                  <input
                                    type="radio"
                                    name="color-option"
                                    defaultValue="white"
                                  />
                                  <span
                                    className="form-option-variant"
                                    style={{ background: "#fff" }}
                                  />
                                </label>
                              </li>
                              <li data-src="images/black-top.jpg">
                                <label>
                                  <input
                                    type="radio"
                                    name="color-option"
                                    defaultValue="black"
                                  />
                                  <span
                                    className="form-option-variant"
                                    style={{ background: "#000" }}
                                  />
                                </label>
                              </li>
                              <li data-src="images/tranding.jpg">
                                <label>
                                  <input
                                    type="radio"
                                    name="color-option"
                                    defaultValue="red"
                                  />
                                  <span
                                    className="form-option-variant"
                                    style={{ background: "#f0afaf" }}
                                  />
                                </label>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* item */}
                    <div className="col-lg-4 col-sm-4 col-xs-6">
                      <div className="product">
                        <div className="product-img">
                          <div className="status-bar">
                            <span className="prd-rating br-5 bg-darkgreen text-white">
                              4.4
                              <i className="lni lni-star" />{" "}
                            </span>
                            <span className="prd-stauts bg-site text-white br-5">
                              {" "}
                              Sold-Out
                            </span>
                            <span className="prd-stauts bg-green text-white br-5">
                              Stock
                            </span>
                            <button className="wishlist-btn">
                              <i className="lni lni-heart" />
                            </button>
                          </div>
                          <a href="#">
                            <img
                              src="images/prd-1.jpg"
                              alt="whiteshut"
                              className="prd-default-img"
                            />
                            <img
                              src="images/prd-2.jpg"
                              alt=""
                              className="prd-hover-img"
                            />
                          </a>
                          <div className="quick-section">
                            <button
                              className="quick-btn"
                              data-toggle="modal"
                              data-target="#modalshow"
                            >
                              Quick View
                            </button>
                          </div>
                        </div>
                        <div className="prd-info">
                          <h4 className="prd-name">
                            <Link to="/product-detail">
                              Astron Cotton Blended Regular Tops -
                              <span className="prd-color">Black</span>
                            </Link>
                          </h4>
                          <div className="prices">
                            <span>$30</span> <del>$70</del>{" "}
                            <span className="tcolor">63% Off</span>
                          </div>
                          <div className="color-option">
                            <ul className="list-style">
                              <li data-src="images/prd-1.jpg">
                                <label>
                                  <input
                                    type="radio"
                                    name="color-option"
                                    defaultChecked=""
                                    defaultValue="white"
                                  />
                                  <span
                                    className="form-option-variant"
                                    style={{ background: "#fbc101" }}
                                  />
                                </label>
                              </li>
                              <li data-src="images/prd-2.jpg">
                                <label>
                                  <input
                                    type="radio"
                                    name="color-option"
                                    defaultValue="black"
                                  />
                                  <span
                                    className="form-option-variant"
                                    style={{ background: "#b41e4e" }}
                                  />
                                </label>
                              </li>
                              <li data-src="images/prd-3.jpg">
                                <label>
                                  <input
                                    type="radio"
                                    name="color-option"
                                    defaultValue="red"
                                  />
                                  <span
                                    className="form-option-variant"
                                    style={{ background: "#f0afaf" }}
                                  />
                                </label>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* item */}
                    <div className="col-lg-4 col-sm-4 col-xs-6">
                      <div className="product">
                        <div className="product-img">
                          <div className="status-bar">
                            <span className="prd-rating br-5 bg-darkgreen text-white">
                              4.4
                              <i className="lni lni-star" />{" "}
                            </span>
                            <span className="prd-stauts bg-site text-white br-5">
                              {" "}
                              Sold-Out
                            </span>
                            <span className="prd-stauts bg-green text-white br-5">
                              Stock
                            </span>
                            <button className="wishlist-btn">
                              <i className="lni lni-heart" />
                            </button>
                          </div>
                          <a href="#">
                            <img
                              src="images/white-top.jpg"
                              alt="whiteshut"
                              className="prd-default-img"
                            />
                            <img
                              src="images/white-top-with-jacket.jpg"
                              alt=""
                              className="prd-hover-img"
                            />
                          </a>
                          <div className="quick-section">
                            <button
                              className="quick-btn"
                              data-toggle="modal"
                              data-target="#modalshow"
                            >
                              Quick View
                            </button>
                          </div>
                        </div>
                        <div className="prd-info">
                          <h4 className="prd-name">
                            <Link to="/product-detail">
                              Astron Cotton Blended Regular Tops -
                              <span className="prd-color">Black</span>
                            </Link>
                          </h4>
                          <div className="prices">
                            <span>$30</span> <del>$70</del>{" "}
                            <span className="tcolor">63% Off</span>
                          </div>
                          <div className="color-option">
                            <ul className="list-style">
                              <li data-src="images/white-top.jpg">
                                <label>
                                  <input
                                    type="radio"
                                    name="color-option"
                                    defaultValue="white"
                                  />
                                  <span
                                    className="form-option-variant"
                                    style={{ background: "#fff" }}
                                  />
                                </label>
                              </li>
                              <li data-src="images/white-top-2.jpg">
                                <label>
                                  <input
                                    type="radio"
                                    name="color-option"
                                    defaultValue="black"
                                  />
                                  <span
                                    className="form-option-variant"
                                    style={{ background: "#000" }}
                                  />
                                </label>
                              </li>
                              <li data-src="images/white-top-with-jacket.jpg">
                                <label>
                                  <input
                                    type="radio"
                                    name="color-option"
                                    defaultValue="red"
                                  />
                                  <span
                                    className="form-option-variant"
                                    style={{ background: "#f0afaf" }}
                                  />
                                </label>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* item */}
                    <div className="col-lg-4 col-sm-4 col-xs-6">
                      <div className="product">
                        <div className="product-img">
                          <div className="status-bar">
                            <span className="prd-rating br-5 bg-darkgreen text-white">
                              4.4
                              <i className="lni lni-star" />{" "}
                            </span>
                            <span className="prd-stauts bg-site text-white br-5">
                              {" "}
                              Sold-Out
                            </span>
                            <span className="prd-stauts bg-green text-white br-5">
                              Stock
                            </span>
                            <button className="wishlist-btn">
                              <i className="lni lni-heart" />
                            </button>
                          </div>
                          <a href="#">
                            <img
                              src="images/kasmiri.jpg"
                              alt="whiteshut"
                              className="prd-default-img"
                            />
                            <img
                              src="images/tranding.jpg"
                              alt=""
                              className="prd-hover-img"
                            />
                          </a>
                          <div className="quick-section">
                            <button
                              className="quick-btn"
                              data-toggle="modal"
                              data-target="#modalshow"
                            >
                              Quick View
                            </button>
                          </div>
                        </div>
                        <div className="prd-info">
                          <h4 className="prd-name">
                            <Link to="/product-detail">
                              Astron Cotton Blended Regular Tops -
                              <span className="prd-color">Black</span>
                            </Link>
                          </h4>
                          <div className="prices">
                            <span>$30</span> <del>$70</del>{" "}
                            <span className="tcolor">63% Off</span>
                          </div>
                          <div className="color-option">
                            <ul className="list-style">
                              <li data-src="images/kasmiri.jpg">
                                <label>
                                  <input
                                    type="radio"
                                    name="color-option"
                                    defaultValue="white"
                                  />
                                  <span
                                    className="form-option-variant"
                                    style={{ background: "#fff" }}
                                  />
                                </label>
                              </li>
                              <li data-src="images/black-top.jpg">
                                <label>
                                  <input
                                    type="radio"
                                    name="color-option"
                                    defaultValue="black"
                                  />
                                  <span
                                    className="form-option-variant"
                                    style={{ background: "#000" }}
                                  />
                                </label>
                              </li>
                              <li data-src="images/tranding.jpg">
                                <label>
                                  <input
                                    type="radio"
                                    name="color-option"
                                    defaultValue="red"
                                  />
                                  <span
                                    className="form-option-variant"
                                    style={{ background: "#f0afaf" }}
                                  />
                                </label>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* item */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="main-section customer-guideline border-top">
        <div className="container">
          <h2 className="fs-20 wow fadeInUp">
            MEET DRESS UP - A WOMEN'S CLOTHING STORE{" "}
          </h2>
          <p className="wow fadeInUp">
            spurious text of the printing and typesetting industry. Lorem Ipsum
            has been the business norm. dummy text ever since the 1500s, when an
            unknown printer took a galley of type and scrambled it to make a
            type specimen book. It has survived not only five centuries, but
            also the leap into electronic typesetting, remaining essentially
            unchanged. It was popularised in the 1960s with the release of
            Letraset sheets containing Lorem Ipsum passages, and more recently
            with desktop publishing software like Aldus PageMaker including
            versions of Lorem Ipsum.
          </p>
          <p className="wow fadeInUp">
            spurious text of the printing and typesetting industry. Lorem Ipsum
            has been the business norm. dummy text ever since the 1500s, when an
            unknown printer took a galley of type and scrambled it to make a
            type specimen book.
          </p>
          <p className="wow fadeInUp">
            <strong>SHOP IN STORE</strong>
          </p>
          <p className="wow fadeInUp">
            Shop all our new arrivals online or in store at one of our store{" "}
            <a title="locations" href="#" className="link">
              locations
            </a>{" "}
            across the Southeast in Delhi ! For a full listing of all our
            brick-and-mortar storefronts and to find the closest Dress Up near
            you, click{" "}
            <a title="locations" href="#" className="link">
              here
            </a>
            !
          </p>
        </div>
      </section>

      <section className="main-section subscribe-section bg-fixed">
        <div className="container">
          <div className="row">
            <div className="col-lg-7 col-sm-9 col-xs-12 m-auto">
              <div className="subscribe-form">
                <h3 className="wow fadeInUp">
                  Join the Design Center point mailing list
                </h3>
                <p>
                  Receive updates about sales, new products, and other great
                  deals.
                </p>
                <form>
                  <div className="form-group">
                    <input
                      type="email"
                      name="email"
                      className="form-control"
                      required=""
                      placeholder="Your Email Address"
                    />
                  </div>
                  <button type="submit" className="btn">
                    Subscribe
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="main-section feature">
        <div className="container">
          <div className="row">
            <div className="col-lg-7 col-sm-7 col-xs-12">
              <div className="row">
                <div className="col-lg-4 col-sm-4 col-xs-12">
                  <div className="feature-box">
                    <div className="feature-img">
                      <span className="mbri-delivery" />
                    </div>
                    <h6>Delivery</h6>
                    <p>within 3 to 7 days of the target.</p>
                  </div>
                </div>
                <div className="col-lg-4 col-sm-4 col-xs-12">
                  <div className="feature-box">
                    <div className="feature-img">
                      <span className="mbri-update" />
                    </div>
                    <h6>Returns</h6>
                    <p>
                      Within ten days of delivery, merchandise with tags
                      attached may be returned..
                    </p>
                  </div>
                </div>
                <div className="col-lg-4 col-sm-4 col-xs-12 footer-box-last">
                  <div className="feature-box">
                    <div className="feature-img">
                      <span className="mbri-lock" />
                    </div>
                    <h6>Safety</h6>
                    <p>Deliveries without contact for optimum security.</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-5 col-sm-5 col-xs-12 feature-right">
              <div className="row">
                <div className="col-lg-6 col-sm-12 col-xs-12">
                  <div className="feature-box need-help">
                    <h6>Need Help?</h6>
                    <p>Our customer service departments are open.</p>
                    <div className="feature-timeing">
                      Mon-Sat [10:00 AM - 05:30 PM]{" "}
                    </div>
                    <div>
                      <a href="mailto:contact@gmail.com" className="link">
                        Contact Us{" "}
                      </a>
                    </div>
                  </div>
                </div>
                <div className="col-lg-6 col-sm-12 col-xs-12">
                  <div className="feature-box need-help">
                    <h6>Where is my order?</h6>
                    <span className="mbri-map-pin" />
                    <a href="#" className="link">
                      Track my Order
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default NewArrivals;
